import React, { useState } from "react";
import { Tabs } from "antd";
import VizHeader from "../VizHeader/VizHeader";
import Overview from "./tabs/overview/Overview";
import SeekerOverview from "./tabs/seeker/seekerOverview";
import ExpertOverview from "./tabs/Expert/ExpertOverview";
import UserTypeSelectComponent from "../UserTypeSelectComponent/UserTypeSelectComponent";
import { useDispatch, useSelector } from "react-redux";
import { Actions } from "../../Action";
import { bindActionCreators } from "redux";
import DocumentOverview from "./tabs/DocumentTab/DocumentOverview";
const textStyles = {
  fontSize: "18px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word',overflowWrap: 'break-word',
};
export default function CmTabs() {
  const cmOverviewReducer = useSelector((state) => state.cmOverview);
  const selectUser = useSelector((state) => state.seekerType);
  const documentUserType = useSelector((state) => state.documentTab);
  // documentTab
  const slack = useSelector((state) => state.slackTab);
  const dispatch = useDispatch();
  const {
    getSelectedUserTypeInOverview,
    SeekerUserTypeAction,
    documentTypeAction,
    cmOverViewSelectTab,
    getTabIndex,
    getSlackTab,
  } = bindActionCreators(Actions, dispatch);
  const onChangeData = (data) => {
    getSelectedUserTypeInOverview(data);
  };
  const onChangeSeeker = (data) => {
    SeekerUserTypeAction(data);
  };
  const onChangeDocument = (data) => {
    documentTypeAction(data);
  };
  const onChangeTab = (e) => {
    // setSelected(e);
    getTabIndex(e);
    if (e == 4) {
      getSlackTab(false);
    }
  };
  // console.log("slack", slack);
  // eslint-disable-next-line no-sparse-arrays
  const renderTitle = (text) => {
    return <span style={{ fontSize: "20px", color: "black" }}>{text}</span>;
  };
  const items = [
    {
      key: "1",
      label: (
        <VizHeader
          type={4}
          isBold={cmOverviewReducer.selectedTab === "1" ? true : false}
        >
          {renderTitle("Overview")}
        </VizHeader>
        // <span style={textStyles}>
        //       {renderTitle("Overview")}

        // </span>
      ),
      children: <Overview />,
    },
    {
      key: "2",
      label: (
        <VizHeader
          type={4}
          isBold={cmOverviewReducer.selectedTab === "2" ? true : false}
        >
          {renderTitle("Seeker")}
        </VizHeader>
      ),
      children: <SeekerOverview />,
    },
    {
      key: "3",
      label: (
        <VizHeader
          type={4}
          isBold={cmOverviewReducer.selectedTab === "3" ? true : false}
        >
          {renderTitle("Expert")}
        </VizHeader>
      ),
      children: <ExpertOverview />,
    },
    {
      key: "4",
      label: (
        <VizHeader
          type={4}
          isBold={cmOverviewReducer.selectedTab === "4" ? true : false}
        >
          {renderTitle("Document")}
        </VizHeader>
      ),
      children: <DocumentOverview />,
    },
  ];
  return (
    <>
      <Tabs
        // tabBarExtraContent={
        //   cmOverviewReducer.selectedTab === "1" ? (
        //     <>
        //       <div style={{ display: "flex", alignItems: "center" }}>
        //         <div style={{ padding: "4px", marginRight: "10px" }}>
        //           User Type:
        //         </div>
        //         <div>
        //           <UserTypeSelectComponent
        //             values={cmOverviewReducer.userTypeSelect}
        //             handler={onChangeData}
        //           />
        //         </div>
        //       </div>
        //     </>
        //   ) : cmOverviewReducer.selectedTab === "2" ? (
        //     <>
        //       <div style={{ display: "flex", alignItems: "center" }}>
        //         <div style={{ padding: "4px", marginRight: "10px" }}>
        //           User Type:
        //         </div>
        //         <div>
        //           <UserTypeSelectComponent
        //             values={selectUser.userType}
        //             handler={onChangeSeeker}
        //           />
        //         </div>
        //       </div>
        //     </>
        //   ) : cmOverviewReducer.selectedTab === "4" ? (
        //     <>
        //       <div style={{ display: "flex", alignItems: "center" }}>
        //         <div style={{ padding: "4px", marginRight: "10px" }}>
        //           User Type:
        //         </div>
        //         <div>
        //           <UserTypeSelectComponent
        //             values={documentUserType.userType}
        //             handler={onChangeDocument}
        //           />
        //         </div>
        //       </div>
        //     </>
        //   ) : null
        // }
        defaultActiveKey={cmOverviewReducer.selectedTab}
        activeKey={cmOverviewReducer.selectedTab}
        items={items}
        onChange={(e) => cmOverViewSelectTab(e)}
        destroyInactiveTabPane
      />
    </>
  );
}
